// @ts-check
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import {digs} from "diggerize"
import Checkbox from "../inputs/checkbox" // eslint-disable-line sort-imports
import InvalidFeedback from "./invalid-feedback"
import PropTypes from "prop-types"
import React from "react"
import classNames from "classnames" // eslint-disable-line import/no-unresolved
import memo from "set-state-compare/build/memo.js"
import useInput from "../use-input.js"

/**
 * @typedef {object} Props
 * @property {string} [attribute]
 * @property {string} [className]
 * @property {boolean} [defaultChecked]
 * @property {boolean | number | string} [defaultValue]
 * @property {React.ReactNode} [hint]
 * @property {string} [id]
 * @property {React.ReactNode} [label]
 * @property {string} [labelClassName]
 * @property {object} [model]
 * @property {string} [name]
 * @property {((event: Event, ...restArgs: Array<unknown>) => void)} [onChange]
 * @property {string} [wrapperClassName]
 * @property {boolean} [zeroInput]
 */
/** @typedef {Record<string, never>} State */
export default memo(shapeComponent(/** @augments {ShapeComponent<Props, State>} */ class ApiMakerBootstrapCheckbox extends ShapeComponent {
  static defaultProps = {
    defaultValue: 1,
    zeroInput: true
  }

  static propTypes = {
    attribute: PropTypes.string,
    className: PropTypes.string,
    defaultChecked: PropTypes.bool,
    defaultValue: PropTypes.any,
    hint: PropTypes.any,
    id: PropTypes.string,
    label: PropTypes.any,
    labelClassName: PropTypes.string,
    model: PropTypes.object,
    name: PropTypes.string,
    onChange: PropTypes.func,
    wrapperClassName: PropTypes.string,
    zeroInput: PropTypes.bool
  }

  setup() {
    const {inputProps, restProps: useInputRestProps, wrapperOpts} = useInput({props: this.props, wrapperOptions: {type: "checkbox"}})

    this.inputProps = inputProps
    this.useInputRestProps = useInputRestProps
    this.wrapperOpts = wrapperOpts
  }

  render () {
    const {inputProps, useInputRestProps, wrapperOpts} = this.tt
    const {className, hint, id, inputRef, label, labelClassName, wrapperClassName, ...restProps} = useInputRestProps
    const {errors} = digs(wrapperOpts, "errors")

    return (
      <div className={this.wrapperClassName()}>
        <div className="form-check">
          <Checkbox
            className={classNames("form-check-input", className, {"is-invalid": errors.length > 0})}
            id={id}
            inputRef={inputRef}
            {...restProps}
          />
          {wrapperOpts.label &&
            <label className={this.labelClassName()} htmlFor={inputProps.id}>
              {wrapperOpts.label}
            </label>
          }
          {hint &&
            <p className="text-muted">
              {hint}
            </p>
          }
          {errors.length > 0 && <InvalidFeedback errors={errors} />}
        </div>
      </div>
    )
  }

  labelClassName () {
    const classNames = ["form-check-label"]

    if (this.props.labelClassName)
      classNames.push(this.props.labelClassName)

    return classNames.join(" ")
  }

  wrapperClassName () {
    const classNames = ["component-bootstrap-checkbox", "form-group"]

    if (this.props.wrapperClassName)
      classNames.push(this.props.wrapperClassName)

    return classNames.join(" ")
  }
}))
